import { Navigate, Outlet, Route, Routes } from "react-router";
import Dashboard from "../pages/dashboard/Dashboard";
import MenuContainer from "./MenuContainer";
import RoleList from "../pages/settings/roles/RoleList";
import UserList from "../pages/settings/users/UserList";
import MaterialTypeList from "../pages/settings/material_type/MaterialTypeList";
import OpenStorageList from "../pages/settings/open_storage/OpenStorageList";
import StoreStorageList from "../pages/settings/store_storage/StoreStorageList";
import ContainerTypeList from "../pages/settings/container_type/ContainerTypeList";
import CementPackagingList from "../pages/settings/cement_packaging/CementPackagingList";
import StorageForm from "../pages/storages/StorageForm";
import StorageDetail from "../pages/storages/StorageDetail";
import UserProfilePage from "../pages/user-profile/UserProfilePage";
import CustomerList from "../pages/customers/CustomerList";
import CustomerAdd from "../pages/customers/CustomerAdd";
import { EmployeeList } from "../pages/employess/staff/EmployeeList";
import { EmployeeDetail } from "../pages/employess/staff/EmployeeDetail";
import { OperationsPage } from "../pages/operations/OperationsPage";
import { SaleOperationsPage } from "../pages/operations/SaleOperationsPage";
import { CabotagePage } from "../pages/operations/CabotagePage";
import { TeamManagementPage } from "../pages/operations/TeamManagementPage";
import { ActivityPage } from "../pages/operations/ActivityPage";
import { SaleOperationsForm } from "../pages/operations/SaleOperationsForm";
import { CreateOperation } from "../pages/operations/components/saleOperations/CreateOperation";
import { SaleOperationsDetails } from "../pages/operations/SaleOperationsDetails";
import { MaterialPage } from "../pages/materials/MaterialPage";
import { MachinePage } from "../pages/materials/MachinePage";
import { GruePage } from "../pages/materials/GruePage";
import { LevagePage } from "../pages/materials/LevagePage";
import { ChalandPage } from "../pages/materials/ChalandPage";
import { TugboatPage } from "../pages/materials/TugboatPage";
import { AddStaff } from "../pages/employess/staff/AddStaff";
import { NotAuthorizedPage } from "../pages/errorPage/NotAuthorized";
import { NotFoundPage } from "../pages/errorPage/NotFoundPage";
import { ErrorPage } from "../pages/errorPage/ErrorPage";
import { WorkCalendar } from "../pages/settings/work_calendar/WorkCalendar";
import OperationFolders from "../pages/operations/components/saleOperations/details/OperationFolders";
import { CabotageForm } from "../pages/operations/CabotageForm";
import { MissingPage } from "../pages/employess/missing/MissingPage";
import { DamagedPage } from "../pages/settings/damaged/DamagedPage";
import { TransportOrderList } from "../pages/transport-order/TransportOrderList";
import { StoragePages } from "../pages/storages/StoragePages";
import { OperationDetails } from "../pages/operations/components/saleOperations/details/OperationDetails";
import { WelcomePage } from "../pages/welcome/WelcomePage";
import { DamagedTypePage } from "../pages/settings/damagedType/DamagedTypePage";
import { DamagedZonePage } from "../pages/settings/damagedZone/DamagedZonePage";
import { Schedules } from "../pages/settings/schedules/Schedules";
import { Booking } from "../pages/container-yard/booking/Booking";
import { GateIn } from "../pages/container-yard/gate-in/GateIn";
import { GateOut } from "../pages/container-yard/gate-out/GateOut";
import { OpenStorage } from "../pages/container-yard/open-storage/OpenStorage";
import { OpenStorageHistory } from "../pages/container-yard/history/OpenStorageHistory";
import { StorageHistory } from "../pages/storages/StorageHistory";
import { OpenStorageDetail } from "../pages/container-yard/open-storage/components/OpenStorageDetail";
import { Files } from "../pages/files/Files";
import { ReleaseOrders } from "../pages/container-yard/release-orders/ReleaseOrders";
import { StorageGatePasses } from "../pages/storages/gate-passes/StorageGatePasses";
import { StorageReleaseOrders } from "../pages/storages/StorageReleaseOrders";
// import useAppStore from "../store/AppStore";
// import { useEffect } from "react";

const PrivateRoutes = () => {
  // const { authorizationData } = useAppStore();

  // useEffect(() => {
  //   if (!authorizationData) {
  //     window.location.href = "/auth/login";
  //   }
  // }, [authorizationData]);

  return (
    <Routes>
      <Route index element={<Navigate to={"/app/dashboard"} replace />} />
      <Route path="/app" element={<MenuContainer />}>
        <Route path="welcome" element={<WelcomePage />} />

        <Route index element={<Navigate to={"/app/dashboard"} replace />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="rh" element={<Outlet />}>
          <Route index element={<EmployeeList />} />
          <Route path="employees" element={<Outlet />}>
            <Route index element={<EmployeeList />} />
            <Route path="detail/:id" element={<EmployeeDetail />} />
            <Route path="add" element={<AddStaff />} />
            <Route path="edit/:id" element={<AddStaff />} />
          </Route>
          <Route path="missing" element={<Outlet />}>
            <Route index element={<MissingPage />} />
          </Route>
        </Route>

        {/* Material routes  */}
        <Route path="material" element={<Outlet />}>
          <Route index element={<MaterialPage />} />
          <Route path="machine" element={<Outlet />}>
            <Route index element={<MachinePage />} />
          </Route>
          <Route path="crane" element={<Outlet />}>
            <Route index element={<GruePage />} />
          </Route>
          <Route path="lifting" element={<Outlet />}>
            <Route index element={<LevagePage />} />
          </Route>
          <Route path="barge" element={<Outlet />}>
            <Route index element={<ChalandPage />} />
          </Route>
          <Route path="tugboat" element={<Outlet />}>
            <Route index element={<TugboatPage />} />
          </Route>
        </Route>

        {/* End Of Material routes  */}
        <Route path="storage" element={<Outlet />}>
          <Route index element={<StoragePages />} />
          <Route path="history" element={<StorageHistory />} />
          <Route path="gate-passes" element={<StorageGatePasses />} />
          <Route path="release-orders" element={<StorageReleaseOrders />} />
          <Route path="new" element={<StorageForm />} />
          <Route path="detail/:id" element={<StorageDetail />} />
        </Route>

        <Route path="customer" element={<Outlet />}>
          <Route index element={<CustomerList />} />
          <Route path="new" element={<CustomerAdd />} />
          <Route path="edit/:id" element={<CustomerAdd />} />
        </Route>

        <Route path="transport-order" element={<Outlet />}>
          <Route index element={<TransportOrderList />} />
        </Route>

        {/* PARC CONTAINER */}
        <Route path="container-yard/booking" element={<Booking />} />
        <Route path="container-yard/gate-in" element={<GateIn />} />
        <Route path="container-yard/gate-out" element={<GateOut />} />
        <Route path="container-yard/open-storage" element={<OpenStorage />} />
        <Route path="container-yard/open-storage/history" element={<OpenStorageHistory />} />
        <Route path="container-yard/open-storage/detail/:id" element={<OpenStorageDetail />} />
        <Route path="container-yard/release-orders" element={<ReleaseOrders />} />

        {/* DOCUMENTS */}
        <Route path="files" element={<Files />} />

        <Route
          path="settings/container-types"
          element={<ContainerTypeList />}
        />
        <Route
          path="settings/cement-packaging"
          element={<CementPackagingList />}
        />
        <Route path="user/profile" element={<UserProfilePage />} />
        <Route path="settings/roles" element={<RoleList />} />
        <Route path="settings/users" element={<UserList />} />
        <Route path="settings/schedules" element={<Schedules />} />
        <Route path="settings/material-types" element={<MaterialTypeList />} />
        <Route path="settings/open-storage" element={<OpenStorageList />} />
        <Route path="settings/store-storage" element={<StoreStorageList />} />
        <Route path="settings/work-calendar" element={<WorkCalendar />} />
        <Route path="settings/damaged-type" element={<DamagedTypePage />} />
        <Route path="settings/damaged-zone" element={<DamagedZonePage />} />
        <Route path="settings/damaged" element={<DamagedPage />} />
        <Route
          path="settings/container-types"
          element={<ContainerTypeList />}
        />
        <Route
          path="settings/cement-packaging"
          element={<CementPackagingList />}
        />
        <Route path="operations" element={<Outlet />}>
          <Route index element={<OperationsPage />} />
          <Route path="sales-operations" element={<Outlet />}>
            <Route index element={<SaleOperationsPage />} />
            <Route path="add" element={<SaleOperationsForm />} />
            <Route path="add" element={<OperationDetails />} />
            <Route path="detail/:id" element={<SaleOperationsDetails />} />
            {/* <Route path="operation/:id" element={<CreateOperation />} /> */}
            <Route path="operation/:id" element={<Outlet />}>
              <Route index element={<CreateOperation />} />
              <Route path="operation-folders" element={<OperationFolders />} />
            </Route>
          </Route>
          <Route path="cabotage" element={<Outlet />}>
            <Route index element={<CabotagePage />} />
            <Route path="add" element={<CabotageForm />} />
            <Route path="detail/:id" element={<SaleOperationsDetails />} />

            {/* <Route path="detail/:id" element={<SaleOperationsDetails />} /> */}
            {/* <Route path="operation/:id" element={<CreateOperation />} /> */}
            <Route path="operation/:id" element={<Outlet />}>
              <Route index element={<CreateOperation />} />
              <Route path="operation-folders" element={<OperationFolders />} />
            </Route>
          </Route>
          {/* <Route path="cabotage" element={<CabotagePage />} /> */}
          <Route path="team-management" element={<TeamManagementPage />} />
          <Route path="activity" element={<ActivityPage />} />
        </Route>
      </Route>
      <Route path="/app/not-authorized" element={<NotAuthorizedPage />} />
      <Route path="/app/not-found" element={<NotFoundPage />} />
      <Route path="/app/error" element={<ErrorPage />} />
      {/* <Route path="*" element={<Navigate to={"/app/not-found"} replace />} /> */}
    </Routes>
  );
};

export default PrivateRoutes;
